import {Component, inject} from '@angular/core';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FormsModule} from '@angular/forms';

import {MatIcon} from '@angular/material/icon';
import {CartStore} from '../../../../store/cart.store';

@Component({
  selector: 'app-order-review-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatIcon
  ],
  templateUrl: './order-review-dialog.html',
  styleUrl: './order-review-dialog.scss'
})
export class OrderReviewDialog {

  private readonly dialogRef = inject(MatDialogRef<OrderReviewDialog>);
  private readonly store = inject(CartStore);


  protected cartItems = this.store.cart().map(item => ({...item}));

  confirm() {

    this.dialogRef.close(this.cartItems);
  }

  close() {
    this.dialogRef.close(null);
  }
}
